(() => {
  const HOST_SELECTOR = 'shopify-forms-embed';
  const STYLE_ID = 'olivah-shopify-forms-brand';
  const observedRoots = new WeakSet();

  const brandedStyles = `
    @font-face {
      font-family: "Louis George Cafe";
      src: url("https://cdn.shopify.com/s/files/1/0968/9110/9750/files/Louis_George_Cafe_Light.woff2?v=1770998684") format("woff2");
      font-weight: 300;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: "Louis George Cafe";
      src: url("https://cdn.shopify.com/s/files/1/0968/9110/9750/files/Louis_George_Cafe.woff2?v=1770998684") format("woff2");
      font-weight: 400 500;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: "Louis George Cafe";
      src: url("https://cdn.shopify.com/s/files/1/0968/9110/9750/files/Louis_George_Cafe_Bold.woff2?v=1770998684") format("woff2");
      font-weight: 600 700;
      font-style: normal;
      font-display: swap;
    }

    :host,
    :host * {
      font-family: "Louis George Cafe", sans-serif !important;
    }

    button[data-testid="form-teaser"]::before,
    section[role="dialog"] h1:first-of-type::before,
    section[role="dialog"] h2:first-of-type::before,
    section[role="dialog"] h3:first-of-type::before {
      content: "";
      display: block;
      flex: 0 0 auto;
      width: 17px;
      height: 17px;
      background-color: #000;
      -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='8' width='18' height='4' rx='1'/%3E%3Cpath d='M12 8v13M5 12v9h14v-9M7.5 8C5.6 8 4.5 7 4.5 5.5S5.6 3 7 3c2.5 0 5 5 5 5M16.5 8c1.9 0 3-1 3-2.5S18.4 3 17 3c-2.5 0-5 5-5 5'/%3E%3C/svg%3E") center / contain no-repeat;
      mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.7' stroke-linecap='round' stroke-linejoin='round'%3E%3Crect x='3' y='8' width='18' height='4' rx='1'/%3E%3Cpath d='M12 8v13M5 12v9h14v-9M7.5 8C5.6 8 4.5 7 4.5 5.5S5.6 3 7 3c2.5 0 5 5 5 5M16.5 8c1.9 0 3-1 3-2.5S18.4 3 17 3c-2.5 0-5 5-5 5'/%3E%3C/svg%3E") center / contain no-repeat;
    }

    button[data-testid="form-teaser"] {
      align-items: center;
      gap: 7px;
      min-height: 38px;
      padding: 8px 10px !important;
    }

    button[data-testid="form-teaser"]::before {
      animation: olivah-gift-nudge 10s ease-in-out infinite;
    }

    button[data-testid="form-teaser"] h3 {
      font-size: 13px !important;
      line-height: 1 !important;
      white-space: nowrap;
    }

    section[role="dialog"] h1:first-of-type::before,
    section[role="dialog"] h2:first-of-type::before,
    section[role="dialog"] h3:first-of-type::before {
      width: 30px;
      height: 30px;
      margin: 0 auto 14px;
    }

    @keyframes olivah-gift-nudge {
      0%, 91%, 100% { transform: rotate(0deg); }
      92% { transform: rotate(-4deg); }
      94% { transform: rotate(4deg); }
      96% { transform: rotate(-3deg); }
      98% { transform: rotate(3deg); }
    }

    @media (max-width: 749px) {
      button[data-testid="form-teaser"] {
        width: auto !important;
        min-width: 49px !important;
        min-height: 34px !important;
        padding: 7px 8px !important;
        gap: 6px !important;
      }

      button[data-testid="form-teaser"] h3 {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        padding: 0 !important;
        margin: -1px !important;
        overflow: hidden !important;
        clip: rect(0, 0, 0, 0) !important;
        white-space: nowrap !important;
        border: 0 !important;
      }

      button[data-testid="form-teaser"]::before {
        width: 16px;
        height: 16px;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      button[data-testid="form-teaser"]::before {
        animation: none;
      }
    }
  `;

  const localizeTeaser = (root) => {
    const isEnglish = document.documentElement.lang.toLowerCase().startsWith('en')
      || location.pathname === '/en'
      || location.pathname.startsWith('/en/');
    const teaserHeading = root.querySelector('button[data-testid="form-teaser"] h3');

    if (isEnglish && teaserHeading?.textContent !== 'A gift') {
      teaserHeading.textContent = 'A gift';
    }
  };

  const brandForm = (host) => {
    const root = host.shadowRoot;
    if (!root) return;

    if (!root.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = brandedStyles;
      root.appendChild(style);
    }

    localizeTeaser(root);

    if (!observedRoots.has(root)) {
      new MutationObserver(() => localizeTeaser(root)).observe(root, {
        childList: true,
        subtree: true,
      });
      observedRoots.add(root);
    }
  };

  const findForms = () => {
    document.querySelectorAll(HOST_SELECTOR).forEach(brandForm);
  };

  findForms();

  new MutationObserver(findForms).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
